"use client";

import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Renders children only for visitors who are not signed in.
 *
 * Signup CTAs on marketing pages are noise for existing users: they already
 * have an account, so "Get started free" is a dead end. Wrap those CTAs in this
 * component to hide them once we know there's a user.
 *
 * Renders children by default: `initialUser` is resolved server-side in
 * ssr-layout, so a signed-in user is known on first paint (no CTA flash), while
 * logged-out visitors and crawlers always get the CTA in the server HTML.
 */
export default function SignedOutOnly({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user) return null;

  return <>{children}</>;
}
